/**
 * used to format endpoints for local or dev
 * @param   {String}  endpoint to go to or gain access to some service
 * @returns {String}
 */
export const setEndpoint = (endpoint = '') => {
  return `${import.meta.env.VITE_INSIGHTS_ENDPOINT}/${endpoint}`;
};
